import React from 'react';
import { Dialog as BPDialog, DialogProps as BPDialogProps, Size } from '@blueprintjs/core-modern';
import './dialog.scss';

export interface DialogProps extends Omit<BPDialogProps, 'className'> {
  size?: Size;
  className?: string;
}

export const Dialog: React.FC<DialogProps> = ({ size = 'small', className = '', ...props }) => {
  const sizeClass = `dialog-${size}`;
  const combinedClassName = [className, sizeClass].filter(Boolean).join(' ');

  return <BPDialog {...props} className={combinedClassName} />;
};
